import { render, staticRenderFns } from "./DialogDemoEmail.vue?vue&type=template&id=7122c424&"
import script from "./DialogDemoEmail.vue?vue&type=script&lang=js&"
export * from "./DialogDemoEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports